






import { Component, Mixins, Prop } from "vue-property-decorator";

@Component({
})
export default class FixedLoading extends Mixins() {
  // v-loading使用した場合、子にclass="el-loading-mask"を含むDOMが生成され、
  // v-loadingの引数がfalseになる際、生成されたDOMに「display: none;」が指定される。
  // IEでは「display: none;」が設定されない場合があるため、このコンポーネントで強制的に与えるようにする。

  @Prop()
  isVisible: boolean;

  get classString(): string {
    return this.isVisible
      ? ""
      : "fixed-loading-hidden";
  }
}
